import React, { useEffect } from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import WordLearningGrid from 'components/WordLearningGrid';
import WordRadical from 'components/WordRadical';
import { useStore, StoreTypes } from 'context';
import * as actionTypes from 'constants/actionTypes';
import { convertIdiomResource } from './wordGridSubContent/gridColumns';
import { WordGridSubContentPanel } from './wordGridSubContent/WordGridSubContentPanel';

const WordLearningGridContainer = ({
  wordGridResource,
  defaultWord,
  idiomResource,
  wordsResource
}) => {
  const [{
    isShowRadicalContent,
    radicalData,
    isShowSubContent,
    word,
    extensionType,
    wordsData,
  }, wordGridDispatch] = useStore(StoreTypes.wordGrid);

  const [{ bookId, books }] = useStore(StoreTypes.books);
  const book = books.find(info => info.bookId === bookId);
  const elementaryHighGradeCheck =
    book.display_name.includes("國小國語5") ||
    book.display_name.includes("國小國語6"); //高年級預設不顯示注音

  useEffect(() => {
    wordGridDispatch({
      type: actionTypes.SET_WORDS_VALUE,
      payload: {
        word: defaultWord
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const subContentCloseHandler = () => {
    wordGridDispatch({ type: actionTypes.SET_SUBCONTENT_SHOW, payload: { isShowSubContent: false } })
  }

  const onRadicalCloseHandler = () => {
    wordGridDispatch({ type: actionTypes.SET_RADICAL_CONTENT_SHOW, payload: { isShowRadicalContent: false, radicalData: null } })
  }

  // 受控：語詞/成語底部清單或字義/字音清單切換生字 → 回寫 store，維持大格子與 subcontent 連動
  const onWordChange = ({ word, relatedWords }) => {
    wordGridDispatch({
      type: actionTypes.SET_SUBCONTENT_SHOW,
      payload: { isShowSubContent: true, extensionType }
    })
    word && wordGridDispatch({
      type: actionTypes.SET_WORDS_VALUE,
      payload: { word }
    })
    wordGridDispatch({
      type: actionTypes.SET_RELATED_WORDS,
      payload: { relatedWords }
    })
  }

  const onExtensionTypeChange = (type) => {
    wordGridDispatch({
      type: actionTypes.SET_SUBCONTENT_SHOW,
      payload: { isShowSubContent: true, extensionType: type }
    })
  }

  const allWords = (wordsData || []).map(d => ({
    word: d.Name,
    extensionData: {
      meaningSet: d.MeaningSet,
      wordsSet: d.WordsSet,
      idiomSet: d.IdiomSet,
      glyphSet: d.GlyphSet,
    },
  }))

  return (
    <>
      <ExtendedContentContainer extendedContentType={ExtendedContentType.WordGrid}>
        <WordLearningGrid dataList={wordGridResource} defaultWord={defaultWord} />
      </ExtendedContentContainer>
      {
        isShowSubContent && (
          <ExtendedContentContainer
            extendedContentType={ExtendedContentType.WordGridSubContent}
            onClose={subContentCloseHandler}
          >
            <WordGridSubContentPanel
              allWords={allWords}
              bookId={bookId}
              initialWord={defaultWord}
              initialExtensionType={extensionType}
              controlledWord={word}
              onWordChange={onWordChange}
              controlledExtensionType={extensionType}
              onExtensionTypeChange={onExtensionTypeChange}
              isElementaryHighGrade={elementaryHighGradeCheck}
              wordsList={convertIdiomResource(wordsResource)}
              idiomList={convertIdiomResource(idiomResource)}
            />
          </ExtendedContentContainer>
        )
      }
      {
        isShowRadicalContent && (
          <ExtendedContentContainer onClose={onRadicalCloseHandler} extendedContentType={ExtendedContentType.WordRadical}>
            <WordRadical data={radicalData} />
          </ExtendedContentContainer>
        )
      }
    </>
  )
}

export const WordGridModalComponent = ({
  wordGridResource,
  defaultWord,
  wordsResource,
  idiomResource
}) => {
  return (
    <WordLearningGridContainer
      wordGridResource={wordGridResource}
      defaultWord={defaultWord}
      wordsResource={wordsResource}
      idiomResource={idiomResource}
    />
  )
};
